import { Component, input } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "tab-formular-input-control",
  templateUrl: "./input-field.component.html",
  styleUrls: ["./input-field.component.scss"],
  standalone: false,
})
export class FormularGroupTabInputControlComponent {

    public inputFormGroup = input.required<FormGroup>();
    public inputFormGroupName = input.required<string>();
    public inputControl = input.required<FormControl>();
    public inputLabel = input.required<string>();
    public htmlType = input.required<string>();
    public isReadOnly = input<boolean>(false);

}